'use client'

import Link from 'next/link'
import useAuth from '../../hooks/useAuth'
import { SIGN_IN_HREF } from './company'
import { ctaClassName } from './ui/cta'

/**
 * The header's right-hand button: "Sign in" for a visitor, "Go to HomeHub" for someone
 * who already has a session. Sign-in is a modal on the homepage, opened by `?login=true`,
 * which `LoginLauncher` handles; from another page the link simply goes home with it.
 */
export function AccountButton() {
  const { user } = useAuth()
  return user ? (
    <Link href="/homehub" className={ctaClassName({ size: 'md' })}>
      Go to HomeHub
    </Link>
  ) : (
    <Link href={SIGN_IN_HREF} className={ctaClassName({ size: 'md' })}>
      Sign in
    </Link>
  )
}
